import type {
  CompensationConfigAllowanceTypes,
  CompensationConfigBonusTypes,
  CompensationConfigRecurrence,
  CompensationConfigTypes,
} from '@omnipresentgroup/types';

export enum FormAction {
  ADD = 'Add',
  UPDATE = 'Update',
}

export enum ColumnHeaders {
  employeeName = 'Employee',
  type = 'Type',
  amount = 'Gross amount',
  isMandatory = 'Mandatory',
  actions = '',
  recurrence = 'Recurrence',
  effectiveDate = 'Start',
  endDate = 'End',
  requestedAt = 'Requested at',
  state = 'State',
  reasonNotes = '',
  source = 'Category',
}

export type ContractualVariantPaymentFormFields = {
  type?: CompensationConfigTypes;
  subtype?: CompensationConfigBonusTypes | CompensationConfigAllowanceTypes;
  recurrence?: CompensationConfigRecurrence;
  amount?: {
    amount: number;
    currency: string;
  };
  reason?: string;
  additionalNotes?: string;
};

export type EmployeeData = {
  id: string;
  currency: string;
  countryCode: string;
};
